import migrateVersion1ToVersion2 from './001.device-group-type-filter';

const migrations = {
  1: migrateVersion1ToVersion2,
  // Add more migrations as needed
};

export default migrations;
